import { Component, computed, input } from '@angular/core';
import { FieldTree, NgValidationError, ValidationError } from '@angular/forms/signals';

@Component({
    selector: 'app-field-errors',
    templateUrl: './field-errors.html',
    styleUrl: './field-errors.css'
})
export class FieldErrorsComponent {
    readonly field = input.required<FieldTree<unknown>>();

    readonly messages = computed(() => {
        const state = this.field()();

        if (!state.touched()) {
            return [];
        }

        return state.errors().map(describeError);
    });
}

function describeError(error: ValidationError.WithFieldTree): string {
    if (error.message) {
        return error.message;
    }

    const known = error as unknown as NgValidationError;

    switch (known.kind) {
        case 'required':
            return 'Este campo é obrigatório.';
        case 'email':
            return 'Informe um e-mail válido.';
        case 'min':
            return `Valor mínimo é ${known.min}.`;
        case 'max':
            return `Valor máximo é ${known.max}.`;
        case 'minLength':
            return `Mínimo de ${known.minLength} caracteres.`;
        case 'maxLength':
            return `Máximo de ${known.maxLength} caracteres.`;
        case 'minDate':
            return `Data mínima é ${known.minDate.toLocaleDateString('pt-BR')}.`;
        case 'maxDate':
            return `Data máxima é ${known.maxDate.toLocaleDateString('pt-BR')}.`;
        case 'pattern':
            return 'Formato inválido.';
        case 'parse':
            return 'Valor inválido.';
        default:
            return `Erro de validação: ${known.kind}`;
    }
}
